// Storage utility with project-specific namespace
const STORAGE_NAMESPACE = process.env.NODE_ENV === "production" 
  ? "nfc_admin_prod_" 
  : "nfc_admin_dev_";

export const storage = {
  // Get item from localStorage or sessionStorage with namespace
  get: (key) => {
    const fullKey = STORAGE_NAMESPACE + key;
    return (
      JSON.parse(sessionStorage.getItem(fullKey)) ||
      JSON.parse(localStorage.getItem(fullKey))
    );
  },

  // Set item in localStorage with namespace
  setLocal: (key, value) => {
    const fullKey = STORAGE_NAMESPACE + key;
    localStorage.setItem(fullKey, JSON.stringify(value));
  },

  // Set item in sessionStorage with namespace
  setSession: (key, value) => {
    const fullKey = STORAGE_NAMESPACE + key;
    sessionStorage.setItem(fullKey, JSON.stringify(value));
  },

  // Remove item from both storages with namespace
  remove: (key) => {
    const fullKey = STORAGE_NAMESPACE + key;
    localStorage.removeItem(fullKey);
    sessionStorage.removeItem(fullKey);
  },

  // Clear all project-specific storage
  clear: () => {
    const keysToRemove = [];
    
    // Get all localStorage keys for this project
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(STORAGE_NAMESPACE)) {
        keysToRemove.push(key);
      }
    }
    
    // Get all sessionStorage keys for this project
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith(STORAGE_NAMESPACE)) {
        keysToRemove.push(key);
      }
    }
    
    // Remove all project-specific keys
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
  },

  // Get namespace for external use
  getNamespace: () => STORAGE_NAMESPACE
}; 